import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { requestPhoneConfirmation } from 'services/api/auth-api.service';

export default function useRequestPhoneConfirmation(
  options?: UseMutationOptions<any, Error, string, unknown>,
) {
  return useMutation({
    mutationFn: requestPhoneConfirmation,
    ...options,
  });
}
